import TextView from "../../TextView"
import styled from 'styled-components';
import MastercardIcon from "assets/images/settings/mastercard.svg";
import VisaIcon from "assets/images/settings/visa.svg";
import JCBIcon from "assets/images/settings/jcb.svg";
import AmericanExpressIcon from "assets/images/settings/americanExpress.svg";
import { colors } from "../../../utils";
import { StyledSubscriptionRowItem } from "./styles";
import { format } from "date-fns";

export const Row = styled.div`
    display: flex;
    gap: 8px;
    margin-left: ${props => props.moreSpacing ? "30px" : "10px"};
`

export const cardIcon = {
  "visa": VisaIcon,
  "mastercard": MastercardIcon,
  "jcb": JCBIcon,
  "amex": AmericanExpressIcon,
}

export const paymentTableColumns = [
  {
    name: "Date",
    selector: (row) => <TextView>{row?.date ? format(new Date(row.date), "MM/dd/yy") : "-"}</TextView>,
    sortable: true,
    sortField: "date",
  },
  {
    name: "Payment Method",
    selector: (row) => (
      <Row moreSpacing={row?.payment_method ? false : true}>
        {row?.payment_method ? (
          <>
            <img src={cardIcon[row?.payment_method.brand]} alt="mastercard" width={24.5} height={16} />
            <TextView>{row?.payment_method.last4}</TextView>
          </>
        ) : (
          <TextView>-</TextView>
        )}
      </Row>
    ),
    sortable: true,
    sortField: "payment_method",
  },
  {
    name: "Transaction",
    selector: (row) => (
      <StyledSubscriptionRowItem
        backgroundColor={
          subscriptionColors[row?.transaction_for?.sub_package]
            ?.backgroundColor || "transparent"
        }
        textColor={
          subscriptionColors[row?.transaction_for?.sub_package]?.textColor ||
          colors.darkGrey
        }
      >
        {row?.transaction_for?.sub_package}
      </StyledSubscriptionRowItem>
    ),
    sortable: true,
    sortField: "transaction_purpose",
  },
  {
    name: "Charge",
    selector: (row) => <TextView>${row?.amount}</TextView>,
    sortable: true,
    sortField: "amount",
  },
];

export const filterOptions = [
    {
      label: "All Time",
      value: "all",
    },
    {
      label: "By Date Range",
      value: "date",
    },
];

export const durationOptions = {
    10: "Month",
    40: "Year",
};

export const durationDisplay = {
  10: "Monthly",
  40: "Annually",
};

export const cardNames = {
  "visa": "Visa Card",
  "mastercard": "MasterCard",
  "jcb": "JCB Card",
  "amex": "American Express Card",
}

export const subscriptionColors = {
    "Essential": {
        backgroundColor: colors.yellowLighter,
        textColor: colors.yellowText
    },
    "Premium": {
        backgroundColor: colors.purpleLighter,
        textColor: colors.purpleText
    },
    "ProSuite": {
        backgroundColor: colors.greenLighter,
        textColor: colors.greenText
    }
}